import { gql } from '@apollo/client'

export const getGraph = gql`
  query getGraph(
    $searchBy: String!
    $entityType: String!
    $depth: String!
    $retrieveSecondaryEntities: Boolean!
  ) {
    getGraph(
      searchBy: $searchBy
      entityType: $entityType
      depth: $depth
      retrieveSecondaryEntities: $retrieveSecondaryEntities
    ) {
      nodes {
        id
        entityType
        data
        feeds
      }
      edges {
        id
        entityType
        target
        source
        data
        feeds
      }
    }
  }
`

export const getEntitiesData = gql`
  query getEntitiesData($entities: [String!]!, $retrieveSecondaryEntities: Boolean!) {
    getEntitiesData(entities: $entities, retrieveSecondaryEntities: $retrieveSecondaryEntities) {
      nodes {
        id
        entityType
        data
        feeds
      }
    }
  }
`

export const getEntityKey = gql`
  query getEntityKey($searchBy: String!) {
    getEntityKey(searchBy: $searchBy) {
      rut
      entityType
      entityKey
    }
  }
`
